import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';

@Injectable()
export class FileListService {
  readonly #httpClient = inject(HttpClient);

  public fetchFile(url: string): Observable<Blob> {
    return this.#httpClient.get(url, { responseType: 'blob' }).pipe(catchError((err: HttpErrorResponse) => of(err.error)));
  }
}
